/* eslint-disable consistent-return */
import t from './DamFolder.type';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import * as DamFolderService from '../../../../services/dam-folder.service';
import { ERROR_MESSAGE } from '../../../../Components/helper';

export const fetchDamFolderGroupList = (params) => async (dispatch) => {
  try {
    const res = await DamFolderService.getDamFolderGroup(params);
    if (res && res.code === 200 && res.data) {
      dispatch({
        type: t.FETCH_DATA_SUCCESS,
        payload: {
          ...params,
          data: params?.isAllRecord ? res.data : res.data.doc,
          totalCount: res?.data?.totalCount,
        },
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchDamFolderGroupByDetailId = (params) => async (dispatch) => {
  try {
    const res = await DamFolderService.getDamFolderGroupById(params);
    if (res && res.code === 200 && res.data) {
      await dispatch({
        type: t.GET_FOLDER_DETAIL,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addDamFolder = (obj, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.addNewDamFolder(obj);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unmountDamFolderData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_FOLDER_DATA,
      payload: null,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editDamFolder = (obj, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.updateDamFolder(obj);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteDamFolderGroupByIdAction = (params, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.deleteDamFolderGroup(params);
    if (res && res.code === 200) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);

      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else {
      toasterMsg(res.message, 'danger');
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const activeInActiveDamGroup = (params, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.activeInActiveDamGroup(params);
    if (res && res.code === 200) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(res?.data?.errMsg, 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchFilesSuggestion = (query) => async (dispatch) => {
  try {
    const res = await DamFolderService.getFilesSuggestions(query);
    if (res && res.code === 200) {
      await dispatch({ type: t.FETCH_FILES_SUGGESTION, payload: res.data });
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteFolderImage = (query, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.deleteFolderImage(query);
    if (res && res.code === 200) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
    return res;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const removeFolderFiles = (folderId, deleteId, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.removeFolderFiles(folderId, deleteId);
    if (res && res.code === 200) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
    return res;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const duplicateFolder = (obj, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.duplicateDamFolder(obj);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.data?.errMsg}`), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const archiveUnarchiveFolders = (obj, transactionMsg) => async () => {
  try {
    const res = await DamFolderService.archiveUnarchiveFolders(obj);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const filterFolderSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_FOLDER_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchDamAcrhivedFolder = (params) => {
  return async (dispatch) => {
    try {
      const response = await DamFolderService.fetchDamAcrhivedFolder(params);
      if (response.code === 200) {
        dispatch({
          type: t.SET_ARCHIVED_FOLDERS,
          payload: {
            ...params,
            data: response?.data.doc,
            totalCount: response?.data?.totalCount,
          },
        });
      }
      return response;
    } catch (error) {
      toasterMsg(ERROR_MESSAGE, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const fetchDamDeletedFolders = (params) => {
  return async (dispatch) => {
    try {
      const response = await DamFolderService.fetchDamDeletedFolders(params);
      if (response.code === 200) {
        dispatch({
          type: t.SET_DELETED_FOLDERS,
          payload: {
            ...params,
            data: response?.data.doc,
            totalCount: response?.data?.totalCount,
          },
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const clearDamFolderGroupList = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_FOLDER_LIST,
      payload: null,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
